module.exports = __webpack_public_path__ + "img/resistance-band.c4987fbf.svg";